import { Action, Module, VuexModule } from "vuex-module-decorators";
import { ZaAudio } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";

@Module
export default class ZaAudioModule extends VuexModule {
    @Action
    [ZaAudio.findPage](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/audio/show`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [ZaAudio.getList](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/audio/list`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [ZaAudio.save](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/audio/insert`,values, {headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [ZaAudio.update](values, onUploadProgress) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/audio/update`,values, {headers: {'Content-Type':'multipart/form-data'}, onUploadProgress: onUploadProgress})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

    @Action
    [ZaAudio.delete](values) {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/audio/delete`,values)
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }

}